import { Component, output } from '@angular/core';
import { ThemeService } from '../../services/theme.service';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-theme-picker',
  imports: [ButtonModule],
  templateUrl: './theme-picker.component.html',
})
export class ThemePickerComponent {

  changed = output();

  constructor(private theme: ThemeService) {}

  toggleDarkMode() {
    this.theme.setDarkOrLightTheme();
    this.changed.emit();
  }
  buttonText() {
    const otherTheme = this.theme.currentThemeMode() === 'dark' ? 'light' : 'dark';
    return `Switch to ${otherTheme} mode`;
  }
}
